import { createNotificationsStore, type NotificationsStore } from "@/stores/notificationsStore";
import { usePhysicianAuthStore } from "@/stores/physicianAuthStore";
import { getPhysicianSocket } from "@/lib/physicianSocket";
import { onResync } from "@/lib/socketRecovery";
import {
  listPhysicianNotificationsApi,
  markAllPhysicianNotificationsReadApi,
  markPhysicianNotificationReadApi,
} from "@/portals/physician/api/physicianNotificationsApi";

let store: NotificationsStore | null = null;

/**
 * The physician portal's own feed — physician socket, session and endpoints.
 * Created on first use so a patient/admin session never instantiates the
 * physician socket just because the shared bell module was imported.
 */
export const getPhysicianNotificationsStore = (): NotificationsStore => (store ??= createNotificationsStore({
  list: listPhysicianNotificationsApi,
  markRead: markPhysicianNotificationReadApi,
  markAllRead: markAllPhysicianNotificationsReadApi,
  onIncoming: (handler) => {
    getPhysicianSocket().on("notification:new", handler);
  },
  onTokenChange: (handler) => {
    // Created lazily, so a physician may already be signed in: report the current
    // token too — on the next microtask, since this runs inside zustand's
    // initializer where the store (and its fetch) doesn't exist yet.
    queueMicrotask(() => handler(usePhysicianAuthStore.getState().accessToken));
    usePhysicianAuthStore.subscribe((state) => handler(state.accessToken));
  },
  onResync: (handler) => {
    onResync(getPhysicianSocket(), handler);
  },
}));
